import React, { FunctionComponent, MouseEventHandler, ReactNode, useState } from 'react';
import SyfoBeOmTilgangModalBoks from './SyfoBeOmTilgangModalBoks';
import './TjenesteInfo.css';
import { navtjenester, NAVtjenesteId } from '../../../altinn/tjenester';
import NyFaneIkon from './NyFaneIkon';
import { Lenke } from '../../../GeneriskeElementer/Lenke';
import { BodyShort, HelpText, Tag } from '@navikt/ds-react';

interface TjenesteInfo {
    tittel: string;
    beskrivelse: string;
}

interface EnAltinnId {
    altinnId: NAVtjenesteId;
}

interface BeOmTilgangAction {
    eksternSide?: boolean /* default value: false */;
    href?: string;
    onClick?: MouseEventHandler<unknown>;
    /** Valgfri status-tag rendret i `.header` til høyre for tittelen. */
    tag?: ReactNode;
}

const hentInfo = (props: TjenesteInfo | EnAltinnId): [string, string] => {
    if ('altinnId' in props) {
        const tjeneste = navtjenester[props.altinnId];
        return [tjeneste.navn, tjeneste.beOmTilgangBeskrivelse];
    } else {
        return [props.tittel, props.beskrivelse];
    }
};

export const BeOmTilgangBoks = (props: (TjenesteInfo | EnAltinnId) & BeOmTilgangAction) => {
    const [tittel, beskrivelse] = hentInfo(props);

    const onClickAction: MouseEventHandler<unknown> = (event) => {
        if (props.href === undefined) {
            event.preventDefault();
        }
        if (props.onClick) {
            props.onClick(event);
        }
    };

    const tittelNode =
        props.href !== undefined || props.onClick !== undefined ? (
            <Lenke href={props.href ?? ''} onClick={onClickAction} className="be-om-tilgang-lenke">
                <span>{tittel} – be om tilgang</span>
                {(props.eksternSide ?? false) ? <NyFaneIkon /> : null}
            </Lenke>
        ) : (
            <BodyShort as={'span'}>
                <span>{tittel}</span>
                {(props.eksternSide ?? false) ? <NyFaneIkon /> : null}
            </BodyShort>
        );

    return (
        <>
            {props.tag !== undefined ? (
                <div className="header">
                    {tittelNode}
                    {props.tag}
                </div>
            ) : (
                tittelNode
            )}
            <BodyShort>{beskrivelse}</BodyShort>
        </>
    );
};

export const BeOmSyfotilgang = () => {
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

    return (
        <>
            <BeOmTilgangBoks
                tittel="Dine sykmeldte"
                beskrivelse="Gå til digitale sykmeldinger og følg opp sykmeldte du har ansvar for."
                onClick={() => setModalIsOpen(true)}
            />
            <SyfoBeOmTilgangModalBoks
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
            />
        </>
    );
};

export interface AltinntilgangAlleredeSøktProps {
    altinnId: NAVtjenesteId;
    status: string;
    statusBeskrivelse: string;
}

export const AltinntilgangAlleredeSøkt: FunctionComponent<AltinntilgangAlleredeSøktProps> = ({
    altinnId,
    status,
    statusBeskrivelse,
}) => (
    <BeOmTilgangBoks
        altinnId={altinnId}
        tag={
            <Tag className="tilgang-sokt-etikett" variant="info" size="medium">
                <span>{status}</span>
                <HelpText title="Hva skjer videre?">{statusBeskrivelse}</HelpText>
            </Tag>
        }
    />
);
